import React, { useEffect } from "react";
import { DirectionForm } from "./Forms/DirectionForm";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Stack } from "react-bootstrap";
import { Container, Form, Spinner } from "reactstrap";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import {
  useGetOneDirectionQuery,
  useUpdateDirectionMutation,
} from "../../services/basicData/basicData";
import { useParams } from "react-router";
import { FormSkeleton } from "./FormFieldSkeletons";

export const EditDirection = () => {
  const { t } = useTranslation();

  const { id } = useParams();
  const {
    data: directionResponse,
    isLoading,
    isFetching,
  } = useGetOneDirectionQuery({ id });
  const direction = directionResponse?.data?.data;
  const loading = isLoading || isFetching;
  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm();
  const { mutate: updateDirection, isPending } = useUpdateDirectionMutation(setError);

  const onSubmit = (data) => {
    updateDirection(data);
  };

  useEffect(() => {
    if (direction) {
      reset(direction);
    }
  }, [direction, reset]);

  return (
    <Stack gap={2}>
      <PageHeader
        title={t("EDIT_DIRECTION")}

      />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          {loading ? (
            <FormSkeleton />
          ) : (
            <>
              <DirectionForm control={control} errors={errors} />
              <Button variant="primary" type="submit" disabled={isPending}>
                {isPending ? (
                  <>
                    <Spinner size="sm" />
                    {t("UPDATING_DIRECTION")}
                  </>
                ) : (
                  t("UPDATE_DIRECTION")
                )}
              </Button>
            </>
          )}
        </Form>
      </Container>
    </Stack>
  );
};

